import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v1/a/basket-item';

class BasketItemEndPoint extends BaseEndpoint {
  count(params){
    return this.client.$get(`${apiPath}/count`, {params});
  }

  items(params) {
    return this.client.$get(`${apiPath}/`, {params});
  }

  refund(data) {
    return this.client.$post(`${apiPath}/refund`, data);
  }
}

export default BasketItemEndPoint;